import fetch from 'isomorphic-unfetch';

async function configureOverlayForm(
  data,
  onResponse: (json?: { field: string; message: string }) => void
) {
  const params = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };

  try {
    const res = await fetch(`/api/blog/quote`, params);

    const jsonResponse = await res.json();

    onResponse(jsonResponse);
  } catch (err) {
    onResponse();
    alert('Error: ' + err);
  }
}

export default configureOverlayForm;
